var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('footer',[_c('div',{staticClass:"nbur"},[_vm._v(" © "+_vm._s(new Date().getFullYear())+", Национальная библиотека Удмуртской Республики ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }